import { useTranslation } from 'react-i18next';
import type { SharedTip } from '../../types';
import { Icon, Lightbulb } from '../../components/ui/Icon';
import { EmptyNote } from './shared.ui';

export default function SharedTips({ tips }: { tips: SharedTip[] }) {
  const { t } = useTranslation();

  if (tips.length === 0) return <EmptyNote>{t('shared.noTips')}</EmptyNote>;

  return (
    <div className="space-y-2">
      {tips.map(tip => (
        <div key={tip.id} className="card px-4 py-3 flex items-start gap-3">
          <div className="w-9 h-9 rounded-xl bg-amber-50 dark:bg-amber-900/30 flex items-center justify-center shrink-0">
            <Icon as={Lightbulb} size={16} className="text-amber-500" />
          </div>
          <div className="min-w-0">
            <p className="font-mono text-[10px] uppercase tracking-widest text-slate-400">{tip.category}</p>
            <p className="text-sm text-slate-700 dark:text-slate-300 mt-0.5 leading-relaxed whitespace-pre-wrap break-words">
              {tip.content}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
